import { RouterView } from 'vue-router';

export const facultyRoutes = {
  path: 'faculties/:id',
  component: () => import('layouts/FacultyLayout.vue'),

  children: [
    {
      name: 'showFaculty',
      path: '',
      redirect: { name: 'showFacultyDashboard' },
    },
    {
      name: 'showFacultyDashboard',
      path: 'dashboard',
      component: () => import('pages/faculty/DashboardPage.vue'),
    },
    {
      name: 'showFacultyPrograms',
      path: 'programs',
      component: () => import('pages/faculty/ProgramList.vue'),
    },
    {
      name: 'showFacultyThesis',
      path: 'theses',
      component: () => import('pages/faculty/thesis/ThesisLayout.vue'),
      redirect: { name: 'showFacultyThesisList' },
      children: [
        {
          path: 'dashboard',
          name: 'showFacultyThesisDashboard',
          component: () => import('pages/faculty/thesis/DashboardPage.vue'),
        },
        {
          path: 'list',
          name: 'showFacultyThesisListRoot',
          component: RouterView,
          children: [
            {
              path: '',
              name: 'showFacultyThesisList',
              component: () => import('pages/faculty/thesis/ListPage.vue'),
            },
            {
              path: ':thesisId',
              name: 'showFacultyThesisShow',
              component: () => import('pages/faculty/thesis/ShowPage.vue'),
            },
          ],
        },
        {
          path: 'external_users',
          name: 'showFacultyExternalSupervisorListRoot',
          component: RouterView,
          children: [
            {
              path: '',
              name: 'showFacultyExternalUserList',
              component: () =>
                import('pages/faculty/thesis/ListExternalUserPage.vue'),
            },
            {
              path: ':externalSupervisorId',
              name: 'showFacultyExternalUserShow',
              component: () =>
                import('pages/faculty/thesis/ShowExternalUserPage.vue'),
            },
          ],
        },
        {
          path: 'supervisor',
          name: 'showFacultySupervisorList',
          component: () =>
            import('pages/faculty/thesis/ListSupervisorPage.vue'),
        },
        {
          path: 'reviewer',
          name: 'showFacultyReviewerList',
          component: () => import('pages/faculty/thesis/ListReviewerPage.vue'),
        },
        {
          path: 'area_professors',
          name: 'showFacultyAreaProfessorList',
          component: () =>
            import('pages/faculty/thesis/ListAreaProfessorPage.vue'),
        },
        {
          path: 'research_coordinator',
          name: 'showFacultyResearchCoordinatorList',
          component: () =>
            import('pages/faculty/thesis/ListResearchCoordinatorPage.vue'),
        },
      ],
    },
    {
      name: 'showFacultyGradeSubmitted',
      path: 'grade_submitted',
      redirect: 'grade_submitted',
      component: RouterView,
      children: [
        {
          path: 'courses',
          name: 'showFacultyGradeSubmittedList',
          redirect: { name: 'showFacultyGradeSubmittedModules' },

          component: () => import('pages/faculty/GradeSubmittedNav.vue'),
          children: [
            {
              name: 'showFacultyGradeSubmittedModules',
              path: 'modules',
              component: () =>
                import('pages/faculty/GradeSubmittedModules.vue'),
            },
          ],
        },
        {
          path: 'show/:courseInstanceId',
          name: 'showFacultyGradeSubmittedShow',
          component: () => import('pages/faculty/GradeSubmittedCourseShow.vue'),
        },

        // {
        //   path: 'core_modules',
        //   name: 'showFacultyGradeSubmittedCoreModules',
        //   component: () =>
        //     import('pages/faculty/GradeSubmittedCoreModules.vue'),
        // },
        // {
        //   path: 'tutorial',
        //   name: 'showFacultyGradeSubmittedTutorial',
        //   component: () => import('pages/faculty/GradeSubmittedTutorial.vue'),
        // },
        // {
        //   path: 'amendments',
        //   name: 'showFacultyGradeSubmittedAmendments',
        //   component: () => import('pages/faculty/GradeSubmittedAmendments.vue'),
        // },
      ],
    },
    {
      name: 'showFacultyGradeSubmittedShow',
      path: 'grade_submitted/:courseInstanceId',
      component: () => import('pages/faculty/GradeSubmittedCourseShow.vue'),
      children: [
        {
          name: 'showFacultyGradeSubmittedShowEnrollment',
          path: 'enrollment/:enrollmentId',
          component: () => import('pages/faculty/GradeSubmittedEnrollment.vue'),
        },
        {
          name: 'showFacultyGradeSubmittedReport',
          path: 'report',
          component: () => import('pages/faculty/GradeSubmittedReport.vue'),
        },
      ],
    },
  ],
};
